export default {
  '401': 'Authentication failed, unable to access system resources',
  '403': 'The current operation does not have permission',
  '404': 'The access resource does not exist',
  'default': 'Unknown system error, please provide feedback to the administrator'
}
